export const NATIVE_2D_FILES_EXTENSIONS = ["slddrw", "dxf"];

export const VALID_2D_FILES_EXTENSIONS = [
  "pdf",
  "tiff",
  "tif",
  "png",
  "jpg",
  "jpeg",
  ...NATIVE_2D_FILES_EXTENSIONS,
];

export const VALID_2D_FILES_ACCEPT: Record<string, string[]> = {
  "application/pdf": [".pdf"],
  "image/tiff": [".tiff", ".tif"],
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "application/slddrw": [".slddrw"],
  "image/vnd.dxf": [".dxf"],
  "application/dxf": [".dxf"],
  "application/x-dxf": [".dxf"],
  "image/x-dxf": [".dxf"],
};

export const is2DFile = <T extends { url?: string; name?: string }>(file: T): boolean => {
  return (
    VALID_2D_FILES_EXTENSIONS.some(
      (ext) =>
        file.url?.toLowerCase().endsWith(`.${ext}`) ||
        (!!file.name && file.name.toLowerCase().endsWith(`.${ext}`)),
    ) || isPdfFile(file)
  );
};

export const isPdfFile = <T extends { url?: string; name?: string }>(file: T): boolean =>
  file.url?.toLowerCase().endsWith(".pdf") ||
  (!!file.name && file.name.toLowerCase().endsWith(".pdf"));
